import React, { createContext } from 'react';
import { createDispatchHook, createSelectorHook, Provider } from 'react-redux';
import createSagaMiddleware from 'redux-saga';
import { applyMiddleware, createStore } from 'redux';
import reducer from './textosPadrao.store';
import watchTextosPadrao from './textosPadrao.saga';


export const textosPadraoContext = createContext();
export const useTextosSelector = createSelectorHook(textosPadraoContext);
export const useTextosDispatch = createDispatchHook(textosPadraoContext);

export default function TextosPadraoProvider({ children }) {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(reducer, applyMiddleware(sagaMiddleware));
  sagaMiddleware.run(watchTextosPadrao);

  return (
    <Provider context={textosPadraoContext} store={store}>
      {children}
    </Provider>
  );
}
